<template>
  <div class="Fillrder">
    <div class="Fillrder-background">
      <div class="appHelmetys">我的订单<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <router-link :to="{path:'Seleress'}">
        <div class="Fillrder-Recods" v-if="Fillyftion.IS_NOT_COUPONS != '0'">
          <div class="Fillrder-Recods-left">
            <p class="Fillrder-Recods-left-content">{{FillSeless.ADDRESS}}</p>
            <p class="Fillrder-Recods-left-title">{{FillSeless.NAME}}<span>{{FillSeless.PHONE}}</span></p>
          </div>
          <div class="Fillrder-Recods-right"><img src="../../public/obraoag/Fillrderford.png" alt=""></div>
        </div>
      </router-link>
      <div class="Fillrder-brder" v-if="Fillyftion.IS_NOT_COUPONS != '0'">
        <img src="../../public/obraoag/Fillrderbrder.png" alt="">
      </div>
      <div v-if="this.Fiarmyte">
        <div v-for="eiFiSetods in FiSetods" :key="eiFiSetods.ID">
          <div v-for="ereiFiSetods in eiFiSetods.goods" :key="ereiFiSetods.ID">
            <div class="Fillrder-comdity" v-if="ereiFiSetods.IS_NOT_CHECK == '0'">
              <div class="Fillrder-comdity-left">
                <img :src="ereiFiSetods.GOODS_IMAGE" alt="">
              </div>
              <div class="Fillrder-comdity-right">
                <p class="Fillrder-comdity-right-title">{{ereiFiSetods.goodsName}}</p>
                <p class="Fillrder-comdity-right-content">规格:{{ereiFiSetods.GOODS_NAME}}</p>
                <div class="Fillrder-comdity-number">
                  <p class="Fillrder-comdity-number-text">￥<span>{{ereiFiSetods.MARKET_PRICE}}</span></p>
                  <div class="Fillrder-comdity-number-purchase">
                    <p class="Fillrder-comdity-number-puce"></p>
                    <p class="Fillrder-comdity-number-puxt">{{ereiFiSetods.SHOPPING_NUMBER}}</p>
                    <p class="Fillrder-comdity-number-puus"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Fillrder-comdity" v-else>
        <div class="Fillrder-comdity-left">
          <img :src="Fillyftion.GOODS_IMAGE" alt="">
        </div>
        <div class="Fillrder-comdity-right">
          <p class="Fillrder-comdity-right-title">{{Fillyftion.goodsName}}</p>
          <p class="Fillrder-comdity-right-content">规格:{{Fillyftion.GOODS_NAME}}</p>
          <div class="Fillrder-comdity-number">
            <p class="Fillrder-comdity-number-text" v-if="maluerID == '0'">￥<span>{{Fillyftion.MARKET_PRICE}}</span></p>
            <p class="Fillrder-comdity-number-text" v-else-if="maluerID == '1'"><span>{{Fillyftion.SCORE_PRICE}}</span></p>
            <div class="Fillrder-comdity-number-purchase" v-if="maluerID == '0'">
              <p class="Fillrder-comdity-number-puce" @click="Fillreduce()">
                <img src="../../public/obraoag/commodityreduce.png" alt="">
              </p>
              <p class="Fillrder-comdity-number-puxt">{{FiPurity}}</p>
              <p class="Fillrder-comdity-number-puus" @click="Fillincrease()">
                <img src="../../public/obraoag/commodityplus.png" alt="">
              </p>
            </div>
            <div class="Fillrder-comdity-number-purchase" v-else-if="maluerID == '1'">
              <p class="Fillrder-comdity-number-puxt Fillrder-comdity-number-pujf">x{{FiPurity}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="Fillrder-poiepr" v-if="maluerID == '1'">
        <p class="Fillrder-poiepr-cent">
          <span>商品金额</span>
          <span>{{Fillyftion.SCORE_PRICE * FiPurity}}</span>
        </p>
        <p class="Fillrder-poiepr-cent">
          <span>运费</span>
          <span>0.00</span>
        </p>
        <p class="Fillrder-poiepr-cent">
          <span>优惠券</span>
          <span class="Fillrder-poiepr-cent-number">暂无可用</span>
        </p>
        <p class="Fillrder-poiepr-setm">
          <span>合计:</span>
          <span class="Fillrder-poiepr-setm-number">{{Fillyftion.SCORE_PRICE * FiPurity}}</span>
        </p>
      </div>
      <div class="Fillrder-Immedment" v-if="maluerID == '0'">
        <p class="Fillrder-Immedment-left">
          <span class="Fillrder-Immedment-left-title">实付:</span>
          <span class="Fillrder-Immedment-left-number">{{Filtprmc ? Filtprmc : Fillyftion.MARKET_PRICE * FiPurity}}</span>
          <span class="Fillrder-Immedment-left-text">免运费</span>
        </p>
        <button @click="FillImment()">立即支付</button>
      </div>
      <div class="Fillrder-redmow" v-else-if="maluerID == '1'">
        <div class="Fillrder-redmow-text" @click="FillImment()">确认兑换</div>
      </div>
    </div>
    <!-- 微信WeUI样式 -->
    <div id="toast" :style="'display:' + FillAppden">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{FillConnts}}</p>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      FillAppden: 'none',
      FillConnts: '',
      customerID: '',
      FiSpeonsID: '',
      FiPurity: '',
      FillSeless: '',
      Fillyftion: '',
      FiSetods: '',
      FillTata: [],
      Fimatarice: 0,
      Fimetarice: 0,
      Finttarice: 0,
      Fiomcoct: {},
      Fipareds: [],
      Fiarmyte: '',
      Filtprmc: '',
      Fimebsce: '',
      Fitealpe: '',
      Fistorid: '',
      Fisrname: '',
      maluerID: ''
    }
  },
  created(){
    // 从缓冲中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 接收商品详情传过来的规格ID和数量、店铺ID和店铺名称
    this.FiSpeonsID = this.$route.query.coSpeonsID;
    this.FiPurity = this.$route.query.coPurity;
    this.Fistorid = this.$route.query.costorid;
    this.Fisrname = this.$route.query.cosrname;
    // 接收购物车传过来的预订单参数和价格
    this.Fiarmyte =  this.$route.query.sharmyte;
    this.Filtprmc =  this.$route.query.shltprmc;
    this.Fimebsce =  this.$route.query.shmebsce;
    this.Fitealpe =  this.$route.query.shtealpe;
    // 通过拼接规格ID获取商品信息
    this.$axios.post('wx/getSpecif',this.$qs.stringify({
      ID: this.FiSpeonsID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.Fillyftion = res.data;
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
    // 通过拼接用户ID获取用户地址信息
    this.$axios.post('wx/addressList',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.FillSeless = res.data.default[0] || '';
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
    // 获取购物车商品信息
    this.$axios.post('wx/shopcart/list',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      showCount: '10',
      currentPage: '1',
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.FiSetods = res.data.varList;
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
  },
  mounted(){
    
  },
  methods:{
    // 点击减少
    Fillreduce(){
      if(Number(this.FiPurity) > '1'){
        this.FiPurity = Number(this.FiPurity) - 1;
      }else{
        this.FillConnts = '最少购买一件哦!';
        this.FillAppden = 'block';
        let that = this;
        setTimeout(function(){
          that.FillAppden = 'none';
        },1400)
      }
    },
    // 点击增加
    Fillincrease(){
      this.FiPurity = Number(this.FiPurity) + 1;
    },
    // 点击立即支付触发
    FillImment(){
      if(this.Fiarmyte){
        // 生成多个商品预支付订单
        this.$axios.post('wx/cardMappCreateBooking',this.$qs.stringify({
          ORDER: this.Fiarmyte,
          MEMBER_ID: this.customerID,
          PHONE: this.FillSeless.PHONE,
          ADDRESS: this.FillSeless.ADDRESS,
          CONSIGNEE_NAME: this.FillSeless.NAME,
          MALL_TYPE: this.maluerID
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.flag == '0'){
            this.$router.push({name: 'Ordesion',query: {FiAderID: res.data.ID,fimaue: this.Filtprmc,fimece: this.Fimebsce,fiinpr: this.Fitealpe}});
          }else{
            this.FillConnts = res.data.msg
            this.FillAppden = 'block'
            let that = this
            setTimeout(function(){
              that.FillAppden = 'none'
            },1400)
          }
        })
        .catch(() => {
            // console.log('未登录获取数据失败');
        });
      }else{
        console.log(this.Fistorid)
        console.log(this.Fisrname)
        var filtec = {}
        var fiwvcn = {}
        var fiinay = []
        this.$set(filtec,'SPECIF_ID',this.FiSpeonsID)
        this.$set(filtec,'SHOPPING_NUMBER',this.FiPurity)
        fiinay.push(filtec)
        this.$set(fiwvcn,'USER_ID',this.Fistorid)
        this.$set(fiwvcn,'merchantsName',this.Fisrname)
        this.$set(fiwvcn,'goods',fiinay)
        this.Fipareds = []
        this.Fipareds.push(fiwvcn)
        // 生成单个商品预支付订单
        this.$axios.post('wx/createBookingorder',this.$qs.stringify({
          ORDER: JSON.stringify(this.Fipareds),
          MEMBER_ID: this.customerID,
          PHONE: this.FillSeless.PHONE,
          ADDRESS: this.FillSeless.ADDRESS,
          CONSIGNEE_NAME: this.FillSeless.NAME,
          MALL_TYPE: this.maluerID
        }),{headers:{'token': this.customerID}})
        .then(res => {
          if(res.data.flag == '0'){
            if(this.maluerID == '0'){
              this.$router.push({name: 'Ordesion',query: {FiAderID: res.data.ID,fimaue: this.Fillyftion.MARKET_PRICE * this.FiPurity,fimece: this.Fillyftion.MEMBER_PRICE * this.FiPurity,fiinpr: this.Fillyftion.NTEGRAL_PRICE * this.FiPurity}});
            }else if(this.maluerID == '1'){
              this.$router.push({name: 'Ordesion',query: {FiAderID: res.data.ID,fimaue: this.Fillyftion.SCORE_PRICE * this.FiPurity}});
            }
          }else{
            this.FillConnts = res.data.msg
            this.FillAppden = 'block'
            let that = this
            setTimeout(function(){
              that.FillAppden = 'none'
            },1400)
          }
        })
        .catch(() => {
          // console.log('未登录获取数据失败');
        });
      }
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Fillrder.css";
</style>